import React from "react";
import {useTrackingGroup} from "../context/TrackingContext";
import {EVENT_NAMES} from "../core/eventNames";
import {toTeaserCardPayload} from "../events/teasercard";

export type UseTeaserCardSelectParams = {
    item?: any;
    dataCypress?: string;
    teasercardLocation?: string;
};

/**
 * useTeaserCardSelect
 *
 * Returns an onClick handler that pushes a gx.teasercard_select event.
 *
 * - Starts a new interaction for the event
 * - Delegates grouping logic to the tracking system via push
 * - Enriches the payload with optional metadata (location, test selectors)
 */
export function useTeaserCardSelect(params: UseTeaserCardSelectParams) {
    const {startInteraction, push} = useTrackingGroup();

    return React.useCallback(
        (_e?: React.MouseEvent<HTMLElement>) => {
            const item = params.item ?? {};
            startInteraction(EVENT_NAMES.TEASERCARD_SELECT);
            void push(
                EVENT_NAMES.TEASERCARD_SELECT,
                toTeaserCardPayload(item, {
                    location: params.teasercardLocation,
                    dataCypress: params.dataCypress,
                })
            );
        },
        [params.item, params.dataCypress, params.teasercardLocation, startInteraction, push]
    );
}
